import sessionKeys from '../constants/sessionKeys'

export default () => JSON.parse(localStorage.getItem(sessionKeys.SUBJECT))
